module.exports = __webpack_public_path__ + "img/undraw_build_your__home_csh6.cece74aa.svg";